import React from 'react';
import PropTypes from 'prop-types';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core';

const ImageFullScreen = ({ children, open, onClose }) => {
  const theme = createMuiTheme({
    overrides: {
      MuiDialog: {
        paper: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#000',
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} onClose={onClose} fullScreen>
        {children}
      </Dialog>
    </ThemeProvider>
  );
};

ImageFullScreen.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default ImageFullScreen;
